import setOrganization from './setOrganization';
import setOrganizations from './setOrganizations';

export default {
  setOrganization,
  setOrganizations,
};
